/**
 * The feature a piece of feedback is about. A union so a typo cannot split one
 * feature's results; a new id must also be on the backend's allowlist.
 */
export type FeatureId = 'data-dictionary' | 'auth-management';

/** Request body of `POST {userFeedback}/v1/tenants/{tenantId}/feedback`. */
export interface ISubmitFeedbackRequest {
    featureId: FeatureId;
    /** Integer from `MIN_RATING` (worst) to `MAX_RATING` (best), sent as picked. */
    rating: number;
    comment?: string;
}

/**
 * 201 response of the same endpoint. The timestamp is the entry's key within the
 * tenant; there is no separate id.
 */
export interface IFeedbackResponse {
    timestamp: string;
}

/** The usual 1-5 scale; the API accepts 0-5. */
export const MIN_RATING = 1;
export const MAX_RATING = 5;

/** What the user has entered so far; kept while the panel is closed. */
export interface IFeedbackDraft {
    rating?: number;
    comment: string;
}

export const EMPTY_DRAFT: IFeedbackDraft = { comment: '' };
